// extracted by mini-css-extract-plugin
export var arrows = "_67-5";
export var decrementer = "_67-9";
export var disabled = "_67-3";
export var error = "_67-1";
export var hiddenText = "_67-a";
export var incrementer = "_67-8";
export var input = "_67-7";
export var inputWrapper = "_67-0";
export var leadingIcon = "_67-b";
export var readonly = "_67-2";
export var regular = "_67-6";
export var small = "_67-4";